import { IndicatorWrap } from './RecordingBottomNavbar.styles';

export interface RecordingIndicatorProps {
  level: number; // normalized 0–1
}

const BAR_COUNT = 16;

export const RecordingIndicator = ({ level }: RecordingIndicatorProps) => {
  const clampedLevel = Math.max(0, Math.min(1, level));

  // Compute bar heights in pixels within a fixed range, modulated by the current level.
  const bars = Array.from({ length: BAR_COUNT }, (_, index) => {
    const t = index / (BAR_COUNT - 1 || 1); // 0–1 across the bars
    // Base shape: center bars taller, outer bars shorter.
    const shape = 0.3 + 0.7 * (1 - Math.abs(t - 0.5) * 2); // roughly 0.3–1
    const height = 8 + shape * clampedLevel * 16; // 8–24px approx
    return { height };
  });

  return (
    <IndicatorWrap>
      <div className="flex h-full w-full items-end gap-[1px]">
        {bars.map((bar, idx) => (
          <div
            key={idx}
            className="flex-1 rounded-sm bg-destructive"
            style={{ height: `${bar.height}px` }}
          />
        ))}
      </div>
    </IndicatorWrap>
  );
};
